import React from 'react'
import Profile  from './Component/Profile/Profile'

function App() {
  return (
    <div>
       <Profile/>
    </div>
  )
}

export default App